module.exports = __webpack_public_path__ + "static/media/icon-kenai-bot-light.b0951b00.svg";